const items = [
  { id: 'idx-1', title: '直播带货', count: '328篇', desc: '带货翻车、选品争议、虚假宣传全收录' },
  { id: 'idx-2', title: '人设崩塌', count: '256篇', desc: '网红虚假人设被揭穿的经典案例' },
  { id: 'idx-3', title: '恋情曝光', count: '189篇', desc: '网红圈地下恋情与分手内幕合集' },
  { id: 'idx-4', title: '平台争议', count: '215篇', desc: '封号、限流、算法调整最新动态' },
  { id: 'idx-5', title: 'MCN内幕', count: '142篇', desc: '机构运作黑幕与签约陷阱揭秘' },
  { id: 'idx-6', title: '商业翻车', count: '167篇', desc: '网红跨界投资与开店失败案例' },
  { id: 'idx-7', title: '粉丝经济', count: '198篇', desc: '割韭菜、数据造假、变现模式分析' },
  { id: 'idx-8', title: '法律纠纷', count: '134篇', desc: '网红涉诉、侵权、合同纠纷汇总' },
  { id: 'idx-9', title: '年度盘点', count: '91篇', desc: '年度网红大事件与话题人物回顾' },
];

export default function IndexSection() {
  return (
    <section id="index" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-6 bg-accent-500 rounded-full"></div>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">专题索引</h2>
          <span className="text-xs text-foreground-500 bg-secondary-100 px-2 py-0.5 rounded-full">全部分类</span>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {items.map((item) => (
            <a
              key={item.id}
              href={`#cards`}
              className="flex items-start gap-3 p-4 bg-background-50 rounded-lg border border-secondary-200/60 hover:border-accent-300 hover:bg-accent-50/30 transition-all cursor-pointer group"
            >
              <div className="flex-shrink-0 w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center">
                <i className="ri-folder-3-line text-accent-600 text-lg"></i>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between mb-1">
                  <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-accent-600 transition-colors">{item.title}</h3>
                  <span className="text-xs text-foreground-500 bg-secondary-100 px-2 py-0.5 rounded-full whitespace-nowrap">{item.count}</span>
                </div>
                <p className="text-xs text-foreground-600">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}